<div class="accountPlaceholderParagraph">
  @for (i of linesArray; track i) {
    <div class="accountPlaceholderParagraph__line" data-testid="placeholderLine"></div>
  }
  @if (ppShowEndElement) {
    <div class="accountPlaceholderParagraph__endLine" data-testid="placeholderEndLine"></div>
  }
</div>
